import React from 'react';
import styled from 'styled-components';
import Logo from '../Logo';
import Row from './Row';
import { Link } from 'react-router-dom';
import QuickMenu from '../QuickMenu';
import BurgerMenu from '../navigation/BurgerMenu';
import { SCREEN_MAX_WIDTH, SCREEN_WIDTH, useGlobalState } from '../stateProvider/StateProvider';
import Col from './Col';
import { BorderLessButton } from '../forms/Button';

const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.background};
    box-shadow: 0px 0px 3px ${({ theme }) => theme.shadow};
    display: flex;
    align-items: center;
    justify-content: center;
    height: 4em;
    position: relative;
`

const Spreader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 100%;
    align-items: center;
    position: relative;
    
    @media (max-width: ${SCREEN_MAX_WIDTH}) {
        justify-content: space-between;
        padding: unset;
    }
`

const LogoWrapper = styled(Link)`
    width: 18em;
    display: flex;
    align-items: center;
    height: 50%;
    @media (max-width: ${SCREEN_MAX_WIDTH}) {
         width: unset;
    }
`

const UserRow = styled(Row)`
    max-width: 500px;
    color: ${({ theme }) => theme.white};
    background: ${({ theme }) => theme.primary};
    height: 100%;
    padding: 0 1em;
`

const Header = ({ children, ...props }) => {
    const { state: { active_user }, logOut } = useGlobalState();

    return (
        <Wrapper>
            <Spreader>
                {SCREEN_WIDTH ? <BurgerMenu style={{ marginLeft: '1em' }} /> : null}

                <Row style={{ height: '100%', padding: '1em' }}>
                    <LogoWrapper
                        to=''
                        aria-label='To the Dashboard'
                    >
                        <Logo text={!SCREEN_WIDTH} />
                    </LogoWrapper>
                </Row>

                <Row style={{ height: '100%', gap: '2em' }}>
                    {!SCREEN_WIDTH && <QuickMenu />}
                    <UserRow>
                        <Row>
                            <Col style={{ gap: '0.2em' }}>
                                <span>{SCREEN_WIDTH ? active_user.firstName : active_user.fullName}</span>
                                {!SCREEN_WIDTH && <b style={{ whiteSpace: 'nowrap' }}>{active_user.companyName}</b>}
                            </Col>
                        </Row>
                        {!SCREEN_WIDTH && <BorderLessButton icon='signOut' onClick={logOut} aria-label='Log Out' />}
                    </UserRow>
                </Row>
            </Spreader>
        </Wrapper>
    );
}

export default Header;
